import * as React from "react"
import { ChakraProvider, LightMode } from "@chakra-ui/react"
import { SelectorList } from "./components/SelectorList/SelectorList"
import { RecoilRoot } from "recoil"
import { ACTFLLevelTable } from "./components/LevelTable/ACTFLLevelTable"
import { CEFRLLevelTable } from "./components/LevelTable/CEFRLLevelTable"
import "./App.css"
import { ModeSelector } from "./components/ModeSelector/ModeSelector"
import { MainTable } from "./components/MainTable/MainTable"

export const App = () => (
	<ChakraProvider>
		<LightMode>
			<RecoilRoot>
				<div className="root-wrapper">
					<div className="header">American and European Language Proficiency Frameworks</div>
					<div className="header-wrapper">
						<SelectorList />
						<ModeSelector />
					</div>
					<div className="table-flex">
						<div>
							<ACTFLLevelTable />
							<CEFRLLevelTable />
						</div>
						<MainTable />
					</div>
					<div className="credits">
						<b>Built at&nbsp;Brown</b>&nbsp;by&nbsp;<a href="https://vivo.brown.edu/display/sgaillar" rel="noreferrer" target="_blank">Prof. Stéphanie Gaillard</a>, Nuj Naguleswaran, and&nbsp;<a href="https://www.xchai.me" rel="noreferrer" target="_blank">Xinzhe Chai</a>
					</div>
					<div className="credits" style={{ width: "700px", fontSize: "12px", marginLeft: "auto", marginRight: "auto", textAlign: "center" }}>
						NCSSFL-ACTFL can-do statements (2017). Progress indicators for language learners. Retrieved August 20, 2022, from https://www.actfl.org/educator-resources/ncssfl-actfl-can-do-statements
						NCSSFL = National Council of State Supervisors for Languages
						ACTFL = American Council on the Teaching of Foreign Languages<br /><br />
						Council of Europe - Common European Framework of Reference for Languages (2001). Self-Assessment Grid. Retrieved August 20, 2022, from : https://www.coe.int/en/web/common-european-framework-reference-languages/table-2-cefr-3.3-common-reference-levels-self-assessment-grid
					</div>
				</div>
			</RecoilRoot>
		</LightMode>
	</ChakraProvider>
)
